import { NgModule } from '@angular/core';
import { ChildElementComponent } from './main-entity-component/child-element/child-element.component';
import { EntityOperationsComponent } from './main-entity-component/entity-operations/entity-operations.component';
import { EntityWithChildsComponent } from './entiy-with-childs.component';
import { MainEntityComponent } from './main-entity-component/main-entity.component';
import { SelectedChildComponent } from './sidebar-selected-child/selected-child.component';
import { BrowserModule } from '@angular/platform-browser';
import { EntitiesService } from '../service/entities.service';
import { NgxCarouselModule } from 'ngx-carousel';

const COMPONENTS = [
    EntityWithChildsComponent,
    ChildElementComponent,
    SelectedChildComponent,
    EntityOperationsComponent,
    MainEntityComponent
 ];

export const entityWithChildsModule: NgModule = {
  declarations: [
    ...COMPONENTS
  ],
  providers: [ 
   EntitiesService
  ],
  imports: [
    BrowserModule,
    NgxCarouselModule
  ],
  entryComponents: COMPONENTS,
   exports: []
};


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/entity/entityWithChilds/entity-with-childs.module.ts